// Primary Fonts
import DomaineSansBoldWoff from './fonts/domaine/DomaineSansText-Bold.woff';
import DomaineSansBoldWoff2 from './fonts/domaine/DomaineSansText-Bold.woff2';
import DomaineSansRegularWoff from './fonts/domaine/DomaineSansText-Regular.woff';
import DomaineSansRegularWoff2 from './fonts/domaine/DomaineSansText-Regular.woff2';
// Secondary Fonts
import DMSansBoldWoff from './fonts/dm-sans/DMSans-Bold.woff';
import DMSansBoldWoff2 from './fonts/dm-sans/DMSans-Bold.woff2';
import DMSansRegularWoff from './fonts/dm-sans/DMSans-Regular.woff';
import DMSansRegularWoff2 from './fonts/dm-sans/DMSans-Regular.woff2';

import { Typography } from '../brands';

const typography: Typography = {
  primary: {
    fontFamily:
      "IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    fontStyle: 'normal',
    sources: {
      bold: [DomaineSansBoldWoff, DomaineSansBoldWoff2],
      regular: [DomaineSansRegularWoff, DomaineSansRegularWoff2],
    },
  },
  secondary: {
    fontFamily:
      "IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    fontStyle: 'normal',
    sources: {
      bold: [DMSansBoldWoff, DMSansBoldWoff2],
      regular: [DMSansRegularWoff, DMSansRegularWoff2],
    },
  },
};

export default typography;
